import { render, staticRenderFns } from "./userlist-waitapproval.vue?vue&type=template&id=3fd3b02a&"
import script from "./userlist-waitapproval.vue?vue&type=script&lang=js&"
export * from "./userlist-waitapproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports